import { Link } from "react-router-dom";
import { Activity, ArrowRight } from "lucide-react";
import { Button } from "../ui/button";

export default function Footer() {
  return (
    <footer
      className="bg-[#0F172A] text-white"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <h2 className="font-outfit text-3xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-balance leading-[1.05] max-w-4xl">
          Ready to see more patients <br className="hidden sm:block" />
          and less paperwork?
        </h2>

        <div className="mt-8 flex flex-col sm:flex-row gap-3">
          <Link to="/signup" data-testid="footer-trial-btn">
            <Button
              size="lg"
              className="w-full sm:w-auto rounded-full bg-[#10B981] hover:bg-[#34D399] text-white font-figtree text-base font-medium px-7 py-6 shadow-[0_10px_25px_rgba(16,185,129,0.35)] transition-all duration-300 hover:-translate-y-0.5"
            >
              Start 15-day free trial
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
          <Link to="/demo" data-testid="footer-demo-btn">
            <Button
              size="lg"
              variant="outline"
              className="w-full sm:w-auto rounded-full bg-transparent hover:bg-white/10 border-white/20 text-white hover:text-white font-figtree text-base font-medium px-7 py-6 transition-all duration-300 hover:-translate-y-0.5"
            >
              Try the demo
            </Button>
          </Link>
        </div>

        <div className="mt-20 pt-10 border-t border-white/10 grid md:grid-cols-12 gap-8 items-start">
          <div className="md:col-span-5">
            <Link
              to="/"
              data-testid="footer-logo-link"
              className="inline-flex items-center gap-2"
            >
              <span className="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-[#10B981] text-white">
                <Activity className="w-5 h-5" strokeWidth={2.5} />
              </span>
              <span className="font-outfit text-xl font-bold tracking-tight">
                TherapyNote
              </span>
            </Link>
            <p className="mt-4 font-figtree text-sm text-white/60 max-w-sm leading-relaxed">
              Voice-first documentation for physiotherapists and sports rehab
              clinics. Built to give you back your evenings.
            </p>
          </div>

          <div className="md:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <div className="font-outfit text-sm font-semibold text-white mb-3">
                Product
              </div>
              <ul className="space-y-2 font-figtree text-sm text-white/60">
                <li>
                  <a href="#how-it-works" className="hover:text-white transition-colors">
                    How it works
                  </a>
                </li>
                <li>
                  <a href="#features" className="hover:text-white transition-colors">
                    Features
                  </a>
                </li>
                <li>
                  <a href="#pricing" className="hover:text-white transition-colors">
                    Pricing
                  </a>
                </li>
                <li>
                  <Link to="/demo" className="hover:text-white transition-colors">
                    Demo
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <div className="font-outfit text-sm font-semibold text-white mb-3">
                Account
              </div>
              <ul className="space-y-2 font-figtree text-sm text-white/60">
                <li>
                  <Link to="/signup" className="hover:text-white transition-colors">
                    Sign up
                  </Link>
                </li>
                <li>
                  <Link to="/login" className="hover:text-white transition-colors">
                    Sign in
                  </Link>
                </li>
                <li>
                  <a href="#faq" className="hover:text-white transition-colors">
                    FAQ
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <div className="font-outfit text-sm font-semibold text-white mb-3">
                Company
              </div>
              <ul className="space-y-2 font-figtree text-sm text-white/60">
                <li>
                  <span className="text-white/40">Privacy</span>
                </li>
                <li>
                  <span className="text-white/40">Terms</span>
                </li>
                <li>
                  <span className="text-white/40">Contact</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 font-figtree text-xs text-white/50">
          <div>© {new Date().getFullYear()} TherapyNote. All rights reserved.</div>
          <div>Built for physios who'd rather be with patients.</div>
        </div>
      </div>
    </footer>
  );
}
